import Editr from "./Editr.vue";

export default {
	install: (Vue, userOptions = {}) => {
		Vue.component("wysiwyg", Editr);
	},

	component: Editr
}
